import React from "react";
import classNames from "classnames";
// import {ErrorMessage} from 'formik';
/* eslint-disable */
// Radio input
const RadioButton = ({
  field: { name, value, onChange, onBlur },
  id,
  label,
  className,
  expect,
  ...props
}) => {
  return (
    <div className="custom-control custom-radio custom-control-inline">
      <input
        name={name}
        id={id}
        type="radio"
        value={expect} // could be something else for output?
        checked={expect === value}
        // onChange={onChange}
        onBlur={onBlur}
        className={classNames("radio-button") +" custom-control-input"}
        {...props}
      />
      <label className="custom-control-label" htmlFor={id}>{label}</label>
    </div>
  );
};
// Radio group
const RadioButtonGroup = ({
    value,
    error,
    touched,
    id,
    label,
    className,
    children
  }) => {
    const classes = classNames(
      "input-field",
      {
        "is-success": value || (!error && touched), // handle prefilled or user-filled
        "is-error": !!error && touched
      },
      className
    );
  
    return (
      <div className={classes}>
        <fieldset>
          <legend className={'radioGroupLegend'}>{label}</legend>
          {children}
          {touched && <InputFeedback error={error} />}
        </fieldset>
      </div>
    );
  }
  // Input feedback
const InputFeedback = ({ error }) =>
error ? <div className={classNames("input-feedback")}>{error}</div> : null;

// Checkbox input
const Checkbox =({
  field: { name, value, onChange, onBlur },
  id,
  label,
  className,
  expect,
  ...props
}) => {
  return (
    <div className="custom-control custom-checkbox custom-control-inline">
      <input
        name={name}
        id={id}
        type="checkbox"
        value={expect} // could be something else for output?
        checked={expect === value}
        // onChange={onChange}
        onBlur={onBlur}
        className={classNames("checkbox-button") +" custom-control-input"}
        {...props}
      />
      <label className="custom-control-label" htmlFor={id}>{label}</label>
    </div>
  );
};

// Checkbox group
const CheckboxGroup = ({
  value,
  error,
  touched,
  id,
  label,
  className,
  children
}) => {
  const classes = classNames(
    "input-field",
    {
      "is-success": value || (!error && touched), // handle prefilled or user-filled
      "is-error": !!error && touched
    },
    className
  );

  return (
    <div className={classes}>
      <fieldset>
        <legend className={'radioGroupLegend'}>{label}</legend>
        {children}
        {touched && <InputFeedback error={error} />}
      </fieldset>
    </div>
  );
}

export {
    Checkbox,
    CheckboxGroup,
    RadioButton,
    RadioButtonGroup,
    InputFeedback //use this for displaying validation errors on custom/un-controlled components
};


/*
Ref
https://gist.github.com/mrtony/c1ba5f8ec4122d2866b292fc36152d34

*/